import "./index.css";
import React from "react";
import { Checkbox } from "antd";

import type { CheckboxProps } from "antd";

interface TypeCheckboxExtendedProps extends CheckboxProps {
  /**
   * @param preview 仅文本预览
   */
  preview?: boolean;
}

/**
 * @name CheckboxExtended 勾选框
 * @description 在 Antd Checkbox 组件上，增加了仅预览功能
 */
const CheckboxExtended: React.FC<TypeCheckboxExtendedProps> = ({
  preview,
  ...props
}) =>
  preview ? (
    <span className="checkbox-preview">
      <img src={`/images/checkbox${props.checked ? "-true" : ""}.svg`} />
      {props.children}
    </span>
  ) : (
    <Checkbox {...props} />
  );

export default CheckboxExtended;
